export default __webpack_public_path__ + "static/dm-c89c964d80e6f8724c0f6cf877c0d7f1.svg";